// ** Initial State
const initialState = {
  connectPageList: [],
  connectParameterList: [],
  connectParameterInfo: {},
  total: 1,
  params: {}
}

const connections = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_CONNECTPARAMETER_LIST':
      return { 
        ...state, 
        connectParameterList: action.data.connectParameterList,
        connectPageList: action.data.connectPageList
      }
    case 'GET_CONNECTPARAMETER_INFO':
      return { 
        ...state, 
        connectParameterInfo: action.data.connectParameterInfo
      }
    case 'INSERT_CONNECTPARAMETER':
    case 'MODIFY_CONNECTPARAMETER':
    case 'DELETE_CONNECTPARAMETER':
      return {
        ...state,
        connectParameterList: action.data
      }
    default:
      return { ...state }
  }
}
export default connections
